import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetAiReviewDetailsQuery = (
  shareToken?: string,
  reviewId?: string,
  refetch?: boolean
) => {
  const { prototypesShare } = useAvApi();

  const data = useQuery({
    queryKey: ['ai-review', shareToken, reviewId],
    queryFn: async () => {
      if (!shareToken || !reviewId) return;
      const data =
        await prototypesShare.getV2PrototypesShareAiReviewsByShareTokenAndReviewId(
          {
            shareToken,
            reviewId,
          }
        );

      return data.data;
    },
    refetchInterval: refetch ? 1000 : undefined,
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return data;
};
